<div class="card m-1">
  <p-breadcrumb [model]="breadItems"></p-breadcrumb>
</div>
<div class="card m-1">

  <div class="card-header bg-gradient-gray-dark text-orange">
    <i class="nav-icon fas fa-envelope"></i>&nbsp;
    <strong>Contact Us</strong>
  </div>
  <div class="card-body">
  
    <div>
      <p>
        If you have any further inquiries or concerns, you can reach us through our contact methods:
      </p>
      <ul>
        <li> <i class="fas fa-envelope"></i>  ccc-eg@orange.com.</li>
        <li> <i class="fas fa-phone"></i>  250 or 16250.</li>
      </ul>
    </div>
  </div>
</div>

